export class RateCodes {
    constructor(
        public productid: any,
        public productname: string,
        public corp: any,
        public rcode: string,
        public corp_id: string,
        public rname: string,
        public f_level: string,
        public proAmount: any,
        public valid_from_dt: Date,
        public valid_to_dt: Date,
        public effdate: Date,
        public corps :number [],
        public changeColor : boolean [],
        public effective_date :Date ,
        public status:string ,
        public createdBy: string,
        public updatedBy:string
    ) { }
}


